import { render } from "./FormView.vue?vue&type=template&id=4ac18a21"
const script = {}

import exportComponent from "/Users/storywriter/projects/webtan_event/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__